import React from 'react';

import Button from '../../elements/Button';
import Input from '../../elements/Input';
import Text from '../../elements/Text';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {getCountryCode} from '../../../utils/HelperMethods';
import {tID} from '../../../utils/TestIdHelper';
import {LockIcon} from '../../../utils/SvgIcons';

const ContactDetails = ({phoneNo, email, setEmail, onPressChangePhone}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <>
      <Text
        testID={tID('ContactDetails-Text-Title')}
        variation="Headline4SemiBold22"
        topMargin={24}
        color={colors.textHeading}>
        Contact Details
      </Text>
      <Input
        testID={tID('ContactDetails-Input-PhoneNumber')}
        editable={false}
        leftText={getCountryCode()}
        inputTitle={'Phone Number'}
        topMargin={24}
        value={phoneNo}
        rightIcon={<LockIcon />}
        style={styles.greyBackground}
      />
      <Button
        testID={tID('ContactDetails-Button-Change')}
        topMargin={24}
        disabled={false}
        style={styles.button}
        onPress={onPressChangePhone}
        title={'Change Phone Number'}
      />
      <Input
        testID={tID('ContactDetails-Input-Email')}
        // hasError={hasError}
        editable={false}
        placeholder={'Type here...'}
        inputTitle={'Email'}
        topMargin={24}
        keyboardType={'email-address'}
        value={email}
        onChangeText={setEmail}
        style={styles.greyBackground}
        rightIcon={<LockIcon />}
      />
    </>
  );
};

export default ContactDetails;
